import { Button, Checkbox, CircularProgress, TextField } from "@mui/material";
import React from "react";
import { useAppSelector } from "../../app/hooks";
import { selectLabels } from "../../slices/language";
import api, { CreateAccGroupRequest } from "../../api";
import { AccessGroupsData } from "../../api/models/access-groups";

interface UserInfo {
  key: string;
  name: string;
  id: number;
}

interface BlockedUsersAccessGroupProps {
  selectedAccessGroup: AccessGroupsData | null;
  extraFunc: () => void;
}

const BlockedUsersAccessGroup = ({
  selectedAccessGroup,
  extraFunc,
}: BlockedUsersAccessGroupProps) => {
  const labels = useAppSelector(selectLabels);

  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [users, setUsers] = React.useState<UserInfo[]>([]);
  const [filteredUsers, setFilteredUsers] = React.useState<UserInfo[]>([]);
  const [selectedUsers, setSelectedUsers] = React.useState<number[]>([]);
  const [userInputValue, setUserInputValue] = React.useState<string>("");

  console.log('selectedAccessGroup', selectedAccessGroup)

  React.useEffect(() => {
    getUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAccessGroup]);

  React.useEffect(() => {
    filterUsers(userInputValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInputValue, users]);

  const getUsers = () => {
    if (selectedAccessGroup) {
      const fixedUsers: UserInfo[] =
        selectedAccessGroup?.banned_users?.map((item) => {
          return {
            key: `${item?.id}`,
            name: item?.name,
            id: item?.id,
          };
        });
      setUsers(fixedUsers);
      setFilteredUsers(fixedUsers); // Inicia con la lista completa
    }
  };

  const filterUsers = (inputValue: string) => {
    if (inputValue) {
      const filtered = users.filter((user) =>
        user.name.toLowerCase().includes(inputValue.toLowerCase())
      );
      setFilteredUsers(filtered);
    } else {
      setFilteredUsers(users); // Si no hay input, muestra todos
    }
  };

  const unlockUser = async () => {
    if (selectedUsers && selectedAccessGroup) {
      const bannedUsers =
        selectedAccessGroup?.banned_users?.map(
          (item) => item?.id
        ) || [];
      const finalBannedUsers = bannedUsers.filter(
        (item) => !selectedUsers.includes(item)
      );
      const payload: CreateAccGroupRequest = {
        data: {
          banned_users: finalBannedUsers,
          configuration: selectedAccessGroup?.configuration,
        },
      };
      try {
        setIsLoading(true);
        const response = await api.updateAccessGroupRequest(
          selectedAccessGroup?.documentId,
          payload
        );
        if (response) {
          extraFunc();
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="w-100" style={{ minWidth: 300 }}>
      {isLoading ? (
        <div
          className="w-100 flex align-items-center justify-content-center"
          style={{ height: 100 }}
        >
          <CircularProgress />
        </div>
      ) : (
        <div className="w-100">
          <p className="t-nowrap body-text-xs mb-3">
            {labels.search_single_user}
          </p>
          <TextField
            fullWidth
            size="small"
            value={userInputValue}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setUserInputValue(event.target.value);
            }}
          />
          {filteredUsers &&
            filteredUsers.length > 0 &&
            filteredUsers.map((item, index) => (
              <div
                key={`${item?.id}-${index}`}
                className="w-100 border-box flex align-items-center justify-content-between pl-3 py-2"
                style={{
                  borderBottom: "1px #e0e0e0 solid",
                  borderTop: index === 0 ? "1px #e0e0e0 solid" : "",
                  marginTop: index === 0 ? 20 : 0,
                }}
              >
                <p>{item?.name}</p>
                <Checkbox
                  checked={selectedUsers.includes(item?.id)}
                  onChange={() => {
                    const dupUsers = [...selectedUsers];
                    if (dupUsers.includes(item?.id)) {
                      const currentIndex = dupUsers.indexOf(item?.id);
                      dupUsers.splice(currentIndex, 1);
                    } else {
                      dupUsers.push(item?.id);
                    }
                    setSelectedUsers(dupUsers);
                  }}
                />
              </div>
            ))}
          <div className="w-100 mt-10">
            <p
              className="t-nowrap body-text-xs mb-3"
              style={{ textAlign: "end" }}
            >
              {selectedUsers.length} {labels.users_selected}
            </p>
            <Button
              fullWidth
              variant="contained"
              disabled={isLoading ? true : selectedUsers.length < 1}
              onClick={unlockUser}
            >
              {labels.unlock}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BlockedUsersAccessGroup;
